// Pending structure-change badge count (WS-driven via useStructureChangeRequestsSocket)

import { useEffect, useSyncExternalStore } from 'react';
import { useAuth } from '../authContext';
import useStructureChangeRequestsSocket from './useStructureChangeRequestsSocket';
import {
  fetchPendingCountOnce,
  getPendingStructureChangeRequestsCount,
  subscribePendingStructureChangeRequestsCount,
} from './structureChangeRequestsWsStore';

let hookMountCount = 0;

/** @deprecated Prefer syncPendingCountFromListCounts or WS payload; kept for approve/dismiss flows. */
export async function refreshPendingStructureChangeRequests() {
  return fetchPendingCountOnce();
}

export function usePendingStructureChangeRequests({ enabled = true } = {}) {
  const { isLoggedIn } = useAuth();
  const wsEnabled = enabled && isLoggedIn;

  useStructureChangeRequestsSocket({
    enabled: wsEnabled,
    isLoggedIn,
  });

  useEffect(() => {
    if (!wsEnabled) return undefined;

    hookMountCount += 1;
    const isFirstMount = hookMountCount === 1;

    if (isFirstMount) {
      fetchPendingCountOnce();
    }

    return () => {
      hookMountCount -= 1;
    };
  }, [wsEnabled]);

  const count = useSyncExternalStore(
    enabled ? subscribePendingStructureChangeRequestsCount : () => () => {},
    enabled ? getPendingStructureChangeRequestsCount : () => 0,
    enabled ? getPendingStructureChangeRequestsCount : () => 0,
  );

  return {
    pendingCount: enabled ? count : 0,
    hasPending: enabled && count > 0,
  };
}
